export const getBlobFromCanvas = (
  canvas: HTMLCanvasElement,
): Promise<Blob | null> =>
  new Promise((resolve, reject) => {
    try {
      canvas.toBlob((blob) => {
        resolve(blob);
      });
    } catch (error) {
      reject(error);
    }
  });
